import { FormSection, FormRow, BigFormRow } from 'framework/ui/layout';
import { Dropdown, TextArea, useDropdownHelper } from 'framework/form';
import { useWasteService, WASTE_REPORTING_METHOD, WASTE_TYPE, OtherExpensesWasteRow } from 'domain/shared/waste';
import LaborCostWasteRow from './LaborCostWasteRow';

interface WasteFormProps {
  title?: string;
  isProjectVisible?: boolean;
  redmineIdentifier?: string;
}

const WasteForm = ({ title = 'Waste Details', isProjectVisible, redmineIdentifier }: WasteFormProps) => {
  const { isHasWithViolations } = useWasteService();
  const { getValue } = useDropdownHelper({ source: 'type' });
  const wasteType = getValue();

  return (
    <>
      <FormSection title={title}>
        <FormRow>
          <Dropdown
            isRequired
            source="type"
            label="Waste Type"
            placeholder="Choose Waste Type"
            options={[
              { value: WASTE_TYPE.LABOR_COST_WASTE, label: 'Labor Cost Waste' },
              { value: WASTE_TYPE.OTHER_EXPENSES_WASTE, label: 'Other Expenses Waste' },
            ]}
          />
          {wasteType === WASTE_TYPE.LABOR_COST_WASTE ? (
            <Dropdown
              isRequired
              source="laborWasteDetails.reportingMethod"
              label="Reporting Method"
              placeholder="Choose Reporting Method"
              options={[
                { value: WASTE_REPORTING_METHOD.BY_EMPLOYEE_AND_TICKET_IDS, label: 'By Employee and Ticket ID(s)' },
                { value: WASTE_REPORTING_METHOD.BY_PROJECT_PERIOD, label: 'By Project and Period' },
                { value: WASTE_REPORTING_METHOD.BY_TICKET_IDS, label: 'By Ticket ID(s)' },
              ].filter(({ value }) => isHasWithViolations || value !== WASTE_REPORTING_METHOD.BY_TICKET_IDS)}
            />
          ) : (
            <></>
          )}
        </FormRow>

        {wasteType === WASTE_TYPE.LABOR_COST_WASTE ? (
          <LaborCostWasteRow
            source="laborWasteDetails"
            isProjectVisible={isProjectVisible}
            redmineIdentifier={redmineIdentifier}
          />
        ) : (
          <></>
        )}
        {wasteType === WASTE_TYPE.OTHER_EXPENSES_WASTE ? <OtherExpensesWasteRow /> : <></>}

        <BigFormRow>
          <TextArea source="reason" />
        </BigFormRow>
      </FormSection>
    </>
  );
};

export default WasteForm;
